import { AppRootView } from "../modules/App/types";

const useGetUrl = (code: string, rootView: AppRootView) => {
  return `${window.location.origin}/${rootView}/${code}`;
};

export default useGetUrl;
